import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';
import { Select, DateRangePicker } from 'ui/components';

import { formatDate } from 'utilities/common';

const initialState = {
  schedule: null,
};

const Filter = ({ show, onClose, ConfigTable, setCount }) => {
  const [{ schedule }, setState] = React.useState(initialState);

  const handleFilter = async (e) => {
    if (ConfigTable?.State?.filter) {
      let x = [];
      Object.keys(ConfigTable?.State?.filter).forEach((k) => {
        if (
          ConfigTable?.State?.filter[k] &&
          k !== 'start_at' &&
          k !== 'document_status'
        ) {
          x.push(k);
        }
      });
      setCount(x);
    }
  };

  const $filterDate = (e) => {
    setState((prevState) => ({
      ...prevState,
      schedule: e,
    }));

    let fm = [];
    e?.forEach((data) => fm?.push(formatDate(data, 'YYYY-MM-DD')));

    ConfigTable?.filter('date_range', fm);
    handleFilter();
  };

  React.useEffect(() => {
    handleFilter();

    let date = [];

    if (ConfigTable?.State?.filter?.start_at && ConfigTable?.State?.filter?.end_at) {
      date.push(new Date(ConfigTable?.State?.filter?.start_at));
      date.push(new Date(ConfigTable?.State?.filter?.end_at));
    }

    setState((prevState) => ({
      ...prevState,
      schedule: date,
      loading: false,
    }));
  }, []);

  return (
    <>
      <div
        className={cn(
          show
            ? 'col-md-3 d-none d-md-block py-3 px-3 m-0 border-start'
            : 'd-none'
        )}
      >
        <div className="mb-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            <div className="page-pretitle fs-7 text-secondary">Filter</div>
            <div className="mt-n1">
              <button className="btn btn-action-close " onClick={onClose}>
                <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
              </button>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Customer</div>
          <Select.Remote
            placeholder=""
            url="/partner"
            params={{'type': 'customer'}}
            row={(d) => {
              return { value: d?.id, label: d?.name };
            }}
            initialValue={ConfigTable?.State?.filter?.customer_id}
            onSelected={(c) => {
              ConfigTable.filter('customer_id', c?.id);
              handleFilter();
            }}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Tanggal Quotation
          </div>
          <DateRangePicker
            value={schedule}
            placeholder=""
            onChange={$filterDate}
          />
        </div>
      </div>

      <>
        <div
          className={cn('filter-overlay', show ? 'd-block d-md-none' : '')}
          onClick={onClose}
        />
        <div
          className={cn(
            'filter-modal d-block d-md-none py-3',
            show ? 'filter-show' : ''
          )}
        >
          <div className="mb-3 border-bottom">
            <div className="d-flex align-items-center justify-content-between">
              <div className="page-pretitle fs-7 text-secondary">Filter</div>
              <div className="mt-n1">
                <button className="btn btn-action-close " onClick={onClose}>
                  <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
                </button>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">Customer</div>
            <Select.Remote
              placeholder=""
              url="/partner"
              params={{'type': 'customer'}}
              row={(d) => {
                return { value: d?.id, label: d?.name };
              }}
              initialValue={ConfigTable?.State?.filter?.customer_id}
              onSelected={(c) => {
                ConfigTable.filter('customer_id', c?.id);
                handleFilter();
              }}
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">
              Tanggal Quotation
            </div>
            <DateRangePicker
              value={schedule}
              placeholder=""
              onChange={$filterDate}
            />
          </div>
        </div>
      </>
    </>
  );
};

export default Filter;
